<template>
  <tr>
    <td class="c-table__cell--left c-table__cell--middle c-table__cell--no-padding is-next" colspan="3" @click="onShowClick">
      <div class="c-cell">
        <p class="date c-table__cell--left c-table__cell--middle" style="width: 261px !important;">{{ deliverDate }} {{ deliverTime }}</p>
        <p class="type u-w260">{{ abtestInfo.abtestTypes[abtest.abtest_type] }}</p>
        <p class="title u-w200 u-text-ellipsis">{{ abtest.abtest_name }}</p>
      </div>
    </td>
  </tr>
</template>

<script>
export default {
  props: {
    abtest: Object,
    abtestInfo: Object,
  },
  emits: ["delete-click","copy-click","show-click"],
  computed: {
    distributionCount: function() {
      let distributionCount = 0;
      let message = this.messageA;
      if(message && message.summary_message_dailies){
        message.summary_message_dailies.forEach(summaryMessageDaily => {
          distributionCount += parseInt(summaryMessageDaily.distribution_count);
        });
      }
      message = this.messageB;
      if(message && message.summary_message_dailies){
        message.summary_message_dailies.forEach(summaryMessageDaily => {
          distributionCount += parseInt(summaryMessageDaily.distribution_count);
        });
      }
      return distributionCount.toLocaleString();
    },
    displayCount: function() {
      let displayCount = 0;
      let message = this.messageA;
      if(message && message.summary_message_dailies){
        message.summary_message_dailies.forEach(summaryMessageDaily => {
          displayCount += parseInt(summaryMessageDaily.display_count);
        });
      }
      message = this.messageB;
      if(message && message.summary_message_dailies){
        message.summary_message_dailies.forEach(summaryMessageDaily => {
          displayCount += parseInt(summaryMessageDaily.display_count);
        });
      }
      return displayCount.toLocaleString();
    },
    messageA: function () {
      let message = null;
      if (this.abtest && this.abtest.abtest_messages.length > 0) {
        message = this.abtest.abtest_messages[0].message;
      }
      return message;
    },
    messageB: function () {
      let message = null;
      if (this.abtest && this.abtest.abtest_messages.length > 1) {
        message = this.abtest.abtest_messages[1].message;
      }
      return message;
    },
    deliverDate: function () {
      let deliverDate = '';
      let message = this.messageA;
      if (message && message.message_deliver) {
        deliverDate = this.getDisplayDate(message.message_deliver.send_start_date);
      }
      return deliverDate;
    },
    deliverTime: function () {
      let deliverDate = '';
      let message = this.messageA;
      if (message && message.message_deliver) {
        deliverDate = this.getDisplayTime(message.message_deliver.send_start_date);
      }
      return deliverDate;
    },
  },
  mounted: function() {
  },
  methods: {
    onDeleteClick: function () {
      this.$emit('delete-click', this.abtest);
    },
    onCopyClick: function () {
      this.$emit('copy-click', this.abtest.abtest_id);
    },
    onShowClick: function () {
      this.$emit('show-click', this.abtest.abtest_id);
    },
  },
};
</script>
